import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

// Exemplu de array cu bot-uri, fiecare având o categorie și un conținut.
// Poți modifica liber titlurile, categoriile și descrierile.
const bots = [
  {
    title: "ChatGPT",
    category: "Chat Bot",
    content: [
      "Model de limbaj dezvoltat de OpenAI.",
      "Poate răspunde la întrebări complexe și genera texte creative.",
    ],
  },
  {
    title: "DeepSeek",
    category: "Chat Bot",
    content: [
      "Specializat în căutări avansate și răspunsuri cu contextualizare profundă.",
      "Ideal pentru domenii de cunoștințe specializate.",
    ],
  },
  {
    title: "Grok",
    category: "Chat Bot",
    content: [
      "Focus pe înțelegerea limbajului natural și explicații pas cu pas.",
      "Poate fi integrat în platforme de suport și asistență rapidă.",
    ],
  },
  {
    title: "Bard",
    category: "Chat Bot",
    content: [
      "Dezvoltat de Google, oferă date și răspunsuri actualizate.",
      "Integrează căutări web în timp real.",
    ],
  },
  {
    title: "MidJourney",
    category: "Image Bot",
    content: [
      "Generare de imagini bazată pe prompt-uri text.",
      "Folosit pe scară largă pentru proiecte creative de design.",
    ],
  },
  {
    title: "Stable Diffusion",
    category: "Image Bot",
    content: [
      "Tehnologie bazată pe modele de tip difuzie pentru imagini.",
      "Permite personalizări avansate pentru artiști și designeri.",
    ],
  },
  {
    title: "Sudowrite",
    category: "Text Generator",
    content: [
      "Ajută scriitorii prin generarea de idei, fraze și paragrafe.",
      "Ideal pentru scenarii, romane sau articole de blog.",
    ],
  },
  {
    title: "Copy.ai",
    category: "Text Generator",
    content: [
      "Platformă pentru creația de conținut publicitar și email-uri de marketing.",
      "Oferă șabloane și sugestii de copywriting.",
    ],
  },
];

// Componenta principală
const InteligențaArtificială = () => {
  // Extragem categoriile unice din array-ul de bots
  const categories = [...new Set(bots.map((bot) => bot.category))];

  // Starea pentru categoria selectată (implicit prima din listă)
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  // Obținem lista de bot-uri care aparțin categoriei selectate
  const filteredBots = bots.filter((bot) => bot.category === selectedCategory);

  // Starea pentru bot-ul selectat (implicit primul bot din categoria curentă)
  const [selectedBot, setSelectedBot] = useState(filteredBots[0]?.title || "");

  // Când utilizatorul alege altă categorie:
  const handleCategoryChange = (event) => {
    const newCategory = event.target.value;
    setSelectedCategory(newCategory);

    // Resetează bot-ul selectat la primul din noua categorie
    const firstBotInCategory = bots.find((bot) => bot.category === newCategory);
    setSelectedBot(firstBotInCategory?.title || "");
  };

  // Când utilizatorul alege alt bot:
  const handleBotChange = (event) => {
    setSelectedBot(event.target.value);
  };

  // Bot-ul curent (după select)
  const currentBot = bots.find((bot) => bot.title === selectedBot);

  return (
    <Container sx={{ marginTop: 4, marginBottom: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Alege Categoria și Bot-ul
      </Typography>

      {/* Select pentru categoria de bot */}
      <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="category-select-label">Categorie</InputLabel>
          <Select
            labelId="category-select-label"
            id="category-select"
            value={selectedCategory}
            label="Categorie"
            onChange={handleCategoryChange}
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Select pentru bot, filtrat după categoria curentă */}
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="bot-select-label">Bot</InputLabel>
          <Select
            labelId="bot-select-label"
            id="bot-select"
            value={selectedBot}
            label="Bot"
            onChange={handleBotChange}
          >
            {filteredBots.map((bot) => (
              <MenuItem key={bot.title} value={bot.title}>
                {bot.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Afișarea detaliilor pentru bot-ul selectat */}
      {currentBot && (
        <Box sx={{ marginTop: 4 }}>
          <Typography variant="h6" gutterBottom>
            {currentBot.title}
          </Typography>
          <Typography variant="body1" gutterBottom>
            Categorie: {currentBot.category}
          </Typography>
          <ul>
            {currentBot.content.map((item, idx) => (
              <li key={idx} style={{ marginBottom: "8px" }}>
                {item}
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Container>
  );
};

export default InteligențaArtificială;
